/**
 * Normaliza un nombre de partner (cliente / proveedor) para comparaciones
 * insensibles a:
 *   - Mayúsculas / minúsculas
 *   - Espacios duplicados, NBSP y bordes
 *   - Puntuación común (. , ; : - _ / \ " ' ` ( ) [ ] { })
 *     → "L.T.D.", "LTD.", "LTD" colapsan todos a "ltd"
 *
 * Espejo en SQL (debe coincidir EXACTAMENTE con normalize_partner_name):
 *   lower(
 *     regexp_replace(
 *       regexp_replace(trim(coalesce(nombre,'')), '[.,;:\-_/\\"''`()\[\]{}]', '', 'g'),
 *       '\s+', ' ', 'g'
 *     )
 *   )
 *
 * Mantén ambos sincronizados o el frontend permitirá lo que la BD rechazará (23505).
 */
export function normalizePartnerName(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .replace(/\u00A0/g, " ")            // NBSP → espacio normal (OCR / copy-paste PDF)
    .replace(/[.,;:\-_/\\"'`()\[\]{}]/g, "") // Quita puntuación común
    .replace(/\s+/g, " ")               // Colapsa espacios múltiples
    .trim()
    .toLowerCase();
}

/** Sentinela usado por los hooks para que la UI muestre un toast amigable */
export const DUPLICATE_NAME_ERROR = "DUPLICATE_NAME";
